import { Action } from '../actions';

const defaultState = {
};

export function user(userState = defaultState, action) {
  switch (action.type) {
    case Action.Identity.User.DetailPending:
      return {
        loading: true,
      };
    case Action.Identity.User.DetailCompleted:
      return {
        ...userState,
        ...action.payload.body,
        loading: false,
      };
    case Action.Identity.User.TxPageCompleted:
      return {
        ...userState,
        tx: action.payload.body.transactions,
        txPage: Math.floor(action.payload.request.body.offset / 5),
      };
    default:
      break;
  }
  return userState;
}
